import { ISettingsService } from "../../../typings/typings";

export const RankingResource = [
    "$resource",
    ($resource: any, SettingsService: ISettingsService) => {
        return $resource(SettingsService.eslapi_host + "/leagues/:leagueId/ranking", { leagueId: "@leagueId" });
    },
];
